const LAYER_TYPES = {
    LAYER: 'layer',
    ICON: 'icon',
    TEXT: 'text',
    SHAPE: 'shape'
};

const LAYER_ROLES = {
    ICON: 'icon',
    BRAND_NAME: 'brandName',
    SLOGAN: 'slogan',
    ELLIPSE: 'ellipse',
    RECTANGLE: 'rectangle'
};

const ROOT_LAYER_TYPES = [
    LAYER_TYPES.ICON,
    LAYER_TYPES.TEXT,
    LAYER_TYPES.SHAPE
];

module.exports = {
    LAYER_TYPES,
    ROOT_LAYER_TYPES,
    LAYER_ROLES
};
